export const selectors = [
  '.tech-form-select.custom-select.year',
  '.tech-form-select.custom-select.month',
  '.tech-form-select.custom-select.day'
]

export const setDay = (defaultYear, year, month, day, monthSelectorStr, daySelectorStr, dayStr = '') => {
  if (!year && defaultYear !== year) {
    month = day = ''
    document.querySelectorAll('.tech-form-select.custom-select.month option').forEach((element) => {
      element.removeAttribute('selected')
    })
    document.querySelector(monthSelectorStr).firstElementChild.setAttribute('selected', 'selected')
  }

  const daySelector = document.querySelector(daySelectorStr)

  document.querySelectorAll('.tech-form-select.custom-select.day option').forEach((element) => {
    element.remove()
  })

  let newElement = document.createElement('option')
  if (dayStr !== '') newElement.innerHTML = dayStr

  if (dayStr === '日') {
    newElement.value = ''
  }

  newElement.setAttribute('selected', 'selected')
  daySelector.appendChild(newElement)

  for (let i = 1; i <= 31; i++) {
    if (month !== '') {
      if ((new Date(year, month - 1, i)).getMonth() !== (month - 1)) break
    }

    newElement = document.createElement('option')
    newElement.innerHTML = `${i}`
    newElement.setAttribute('value', `${i}`)
    if (parseInt(day) === i) {
      newElement.setAttribute('selected', 'selected')
    }

    daySelector.appendChild(newElement)
  }

  return year
}
